import type { AuditEventName } from '@onefootprint/request-types/dashboard';
import { FilterDateRange, Form } from '@onefootprint/ui';
import { useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FiltersDrawer from '@/components/filters-drawer';
import useSecurityLogsQueryParams from '@/hooks/use-security-logs-filters';
type FormValues = {
  dateRange: FilterDateRange;
  names: AuditEventName[];
};
const EVENTS: AuditEventName[] = ['update_user_data', 'delete_user_data', 'decrypt_user_data', 'create_org_role', 'update_org_role', 'deactivate_org_role', 'invite_org_member', 'update_org_member', 'remove_org_member', 'decrypt_org_api_key', 'update_org_api_key_status', 'update_org_api_key_role', 'manually_review_entity'];
const Filters = () => {
  const {
    t
  } = useTranslation('security-logs', {
    keyPrefix: 'filters'
  });
  const {
    t: tEvents
  } = useTranslation('security-logs', {
    keyPrefix: 'filters.events'
  });
  const [isOpen, setIsOpen] = useState(false);
  const {
    push,
    clearFilters,
    values,
    filtersCount
  } = useSecurityLogsQueryParams();
  const formMethods = useForm<FormValues>({
    defaultValues: {
      dateRange: values.dateRange,
      names: values.names as AuditEventName[]
    }
  });
  const {
    handleSubmit,
    reset,
    control,
    watch
  } = formMethods;
  const [dateRange, names] = watch(['dateRange', 'names']);
  const handleOpenChange = (nextOpen: boolean) => {
    reset({
      dateRange: values.dateRange,
      names: values.names as AuditEventName[]
    });
    setIsOpen(nextOpen);
  };
  const onSubmit = (data: FormValues) => {
    push({
      names: data.names,
      dateRange: data.dateRange
    });
    setIsOpen(false);
  };
  const handleClear = () => {
    clearFilters();
    setIsOpen(false);
  };
  const dateOptions = [{
    label: t($ => $.period.allTime),
    value: FilterDateRange.AllTime
  }, {
    label: t($_0 => $_0.period.today),
    value: FilterDateRange.Today
  }, {
    label: t($_1 => $_1.period.last7Days),
    value: FilterDateRange.Last7Days
  }, {
    label: t($_2 => $_2.period.last30Days),
    value: FilterDateRange.Last30Days
  }];
  return <FiltersDrawer count={filtersCount} open={isOpen} onOpenChange={handleOpenChange} onApply={handleSubmit(onSubmit)} onClear={handleClear}>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <FiltersDrawer.Section title={t($_3 => $_3.dates.header)} count={dateRange === FilterDateRange.AllTime ? 0 : 1} defaultOpen>
            <Controller control={control} name="dateRange" render={({
            field
          }) => <FiltersDrawer.Chips aria-label={t($_4 => $_4.dates.header)} options={dateOptions} value={field.value} onChange={field.onChange} />} />
          </FiltersDrawer.Section>
          <FiltersDrawer.Section title={t($_5 => $_5.events.header)} count={names.length} defaultOpen>
            <FiltersDrawer.List>
              <Form.CheckboxGroup<FormValues> name="names"
            // @ts-expect-error - EVENTS is a subset of AuditEventName
            options={EVENTS.map(name => ({
              label: tEvents($_6 => $_6[name]),
              value: name
            }))} className="flex flex-col gap-2" />
            </FiltersDrawer.List>
          </FiltersDrawer.Section>
        </form>
      </FormProvider>
    </FiltersDrawer>;
};
export default Filters;